import { ajaxJson } from 'imports/ajax';
import { createTypes } from 'redux-create-types';

const namespace = 'invoice';

export const invoiceActions = createTypes([
    'toggleSpinner',
    'setError',
    'setInvoiceDetail',
], namespace);

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: invoiceActions.toggleSpinner,
            payload: true,
            meta: {apiName}
        });
    }
}

function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: invoiceActions.toggleSpinner,
            payload: false,
            meta: {apiName}
        });
    }
}


function setInvoiceDetail(invoice) {
    return dispatch => {
        return dispatch({
            type: invoiceActions.setInvoiceDetail,
            payload: invoice,
        });
    }
}

function getInvoiceDetailApiFail(err) {
    return dispatch => {
        dispatch({
            type: invoiceActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('user-invoices'));
    }
}

function getInvoiceDetailApiSuccess(res) {
    return dispatch => {
        dispatch(hideSpinner('user-invoices'));
        return dispatch(setInvoiceDetail(res.data))
    }
}


function getInvoiceDetailFromApi(invoiceId) {
    return dispatch => {
        dispatch(showSpinner('user-invoices'))
        return ajaxJson.get(`/payments/invoices/${invoiceId}/detail`)
        .then(
            res => dispatch(getInvoiceDetailApiSuccess(res)),
            err => dispatch(getInvoiceDetailApiFail(err)),
        )
    }
}

export const invoiceActionCreators = {
    getInvoiceDetailFromApi,
}